import React from 'react';


function TermsOfService() {
  return (
    <div className="services-page">
      <h2>Terms of Service</h2>
      <p><em>Last updated: September 28, 2025</em></p>
      <h3>1. Acceptance of Terms</h3>
      <p>
        By accessing or using Build Jamaica (“we”, “us”, or “our”), you agree to be bound by these Terms of Service. If you do not agree, please do not use our website or services.
      </p>
      <h3>2. Services Provided</h3>
      <p>
        We provide property, project management, building, and maintenance services by connecting users with contractors and service providers in Jamaica. We act as a facilitator and are not responsible for the actions or omissions of third-party contractors.
      </p>
      <h3>3. User Responsibilities</h3>
      <ul>
        <li>Provide accurate and complete information when using our services</li>
        <li>Use our platform for lawful purposes only</li>
        <li>Respect the rights and privacy of other users and contractors</li>
      </ul>
      <h3>4. Data and Privacy</h3>
      <p>
        Your use of our services is also governed by our <a href="/privacy-policy" style={{ color: '#007b5e' }}>Privacy Policy</a>.
      </p>
      <h3>5. Third-Party Services</h3>
      <p>
        We may connect you with independent contractors or service providers. We are not liable for their actions, omissions, or the quality of their work. Any agreements or disputes with third parties are solely between you and them.
      </p>
      <h3>6. Limitation of Liability</h3>
      <p>
        We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of our services or the actions of third parties.
      </p>
      <h3>7. Account Termination</h3>
      <p>
        We reserve the right to suspend or terminate your access to our services at our discretion, especially if you violate these terms or use our platform unlawfully.
      </p>
      <h3>8. Changes to Terms</h3>
      <p>
        We may update these Terms of Service from time to time. Changes will be posted on this page with an updated effective date.
      </p>
      <h3>9. Governing Law</h3>
      <p>
        These terms are governed by the laws of Jamaica. Any disputes will be resolved in the courts of Jamaica.
      </p>
      <h3>10. Contact Us</h3>
      <p>
        For questions about these terms, please contact us at <a href="mailto:info@build-jamaica.com">info@build-jamaica.com</a>.
      </p>
    </div>
  );
}

export default TermsOfService;
